import { LoaderWrapper, Card, BackButton } from '@fl/cmsch-fe-library';
import React, { FC, memo } from 'react';
import { Content } from 'app/content';
import { useOurTranslation } from 'app/translations';
import { ApcReportForm } from '../components/apc-report-form';
import { CreatedApcReportsTable } from '../components/created-apc-reports-table';
import { useNewApcReportScreenSetup } from '../hooks/use-new-apc-report-screen-setup';
const NewApcReportBase: FC = () => {
  const {
    header,
    tCommon,
    correctionReportDetailLoading,
    earTagRef,
    technicianNumberRef,
    correctionTypeRef,
    createdCorrectionReports,
    goBackToList,
    createCorrectionReport,
    onCancel,
    deleteCreatedApcReport,
    editCreatedApcReport,
    resetCreatedApcReports
  } = useNewApcReportScreenSetup();
  const {
    t
  } = useOurTranslation('analysisProtocolCorrection');
  return <Content browserTabTitle={t('analysisProtocolCorrectionReportOverview')} data-sentry-element="Content" data-sentry-component="NewApcReportBase" data-sentry-source-file="new-apc-report.tsx">
            <Card title={header} titleSize="medium" extra={<BackButton text={tCommon('backToList')} onClick={goBackToList} />} data-sentry-element="Card" data-sentry-source-file="new-apc-report.tsx">
                <LoaderWrapper loading={correctionReportDetailLoading} data-sentry-element="LoaderWrapper" data-sentry-source-file="new-apc-report.tsx">
                    <ApcReportForm correctionTypeRef={correctionTypeRef} earTagRef={earTagRef} technicianNumberRef={technicianNumberRef} onSubmit={createCorrectionReport} onCancel={onCancel} data-sentry-element="ApcReportForm" data-sentry-source-file="new-apc-report.tsx" />
                </LoaderWrapper>
                <CreatedApcReportsTable createdApcReports={createdCorrectionReports} deleteCreatedApcReport={deleteCreatedApcReport} editCreatedApcReport={editCreatedApcReport} resetCreatedApcReports={resetCreatedApcReports} data-sentry-element="CreatedApcReportsTable" data-sentry-source-file="new-apc-report.tsx" />
            </Card>
        </Content>;
};

/**
 * Renders the screen used for creating and editing analysis protocol correction reports.
 *
 * @returns The correction form together with the local table of created reports.
 */
export const NewApcReport = memo(NewApcReportBase);